document.addEventListener("DOMContentLoaded", function () {
  $(document).on("click", ".product-card-new-variant", function () {
    $(this).addClass("active").siblings().removeClass("active");

    let image = $(this).data("image");
    if (image) {
      $(this)
        .parents(".product-item-variant__properties")
        .find(".product-card-image_varaint__properties img")
        .removeAttr("srcset")
        .attr("src", image);
    }

    $(this)
      .parents(".product-item-variant__properties")
      .find("a")
      .attr("href", $(this).data("url"));

    let price = $(this).data("price");
    let compare_at_price = $(this).data("compare_at_price");

    if (price) {
      const priceText = $("<div>").html(price).text();
      $(this)
        .parents(".product-item-variant__properties")
        .find(".price--highlight")
        .text(priceText);
    }

    if (compare_at_price) {
      const compareText = $("<div>").html(compare_at_price).text();
      $(this)
        .parents(".product-item-variant__properties")
        .find(".price--compare")
        .text(compareText);
    } else {
      $(this)
        .parents(".product-item-variant__properties")
        .find(".price--compare")
        .text("");
    }
  });
});
